import useImageLoader from './useImageLoader'

function UserImageRound({ src, fallbackSrc, alt = 'user', className }) {
  const imageSrc = useImageLoader(src, fallbackSrc);

  return (
    <img
      className={className}
      src={imageSrc}
      alt={alt}
      onError={(e) => {
        e.target.src = fallbackSrc;
      }}
    />
  );
}

export default UserImageRound;